// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import * as types from './actionTypes';

export function startLoading() {
  return {
    type: types.VOUCHER_CONFIRMED_START_LOADING,
  };
}

export function stopLoading() {
  return {
    type: types.VOUCHER_CONFIRMED_STOP_LOADING,
  };
}

export function setBookshopCustomer(payload) {
  return {
    type: types.VOUCHER_CONFIRMED_SET_BOOKSHOP_CUSTOMER,
    payload,
  };
}

export function changeRedeemValue(value, field) {
  return {
    type: types.VOUCHER_CONFIRMED_CHANGE_REDEEM_VALUE,
    value,
    field
  };
}

export function validateRedeemValue(payload) {
  return {
    type: types.VOUCHER_CONFIRMED_VALIDATE_REDEEM_VALUE,
    payload
  };
}

export function resetForm() {
  return {
    type: types.VOUCHER_CONFIRMED_RESET_FORM,
  };
}

export function openConfirmModal() {
  return {
    type: types.VOUCHER_CONFIRMED_OPEN_CONFIRM_MODAL,
  };
}

export function closeConfirmModal() {
  return {
    type: types.VOUCHER_CONFIRMED_CLOSE_CONFIRM_MODAL,
  };
}
export function redeemVoucher() {
  return {
    type: types.VOUCHER_CONFIRMED_REDEEM_VOUCHER,
  };
}

export function redeemVoucherSuccess(payload) {
  return {
    type: types.VOUCHER_CONFIRMED_REDEEM_VOUCHER_SUCCESS,
    payload,
  };
}
